

























































import CreateDialogVue from '@/components/CreateDialog.vue'
import { editMixin } from '@/utils/mixins/editMixin'
import { crudMixin } from '@/utils/mixins/crudMixin'
import mixins from 'vue-typed-mixins'
import { Provider, SharedProvider } from '@/utils/interfaces/topup.interface'
import { createOrUpdateSharedProvider } from '@/api/Topup/topup.api'
import { getAgencies } from '@/api/Agency/agency.api'
import Autocomplete from '@/components/Autocomplete.vue'
import { getAgencyProviders } from '@/utils/functions'
import { Params, VueForm } from '@/utils/interfaces'

export default mixins(editMixin, crudMixin).extend({
  components: {
    appCreateDialog: CreateDialogVue,
    appAutocomplete: Autocomplete,
  },
  data() {
    return {
      rules: {
        required: (v: string) => !!v || this.$t('field-required'),
      },
      defaultCrud: {
        name: '',
        parent_provider: '',
        agency: '',
        is_active: true,
        can_share: false,
      } as SharedProvider,
      crud: {} as SharedProvider,
      getAgencies: (params?: Params) =>
        getAgencies({ ...params, not_self: true }),
      getProviders: getAgencyProviders,
      loading: false,
      providers: [] as Provider[],
      loadingProviders: false,
    }
  },
  methods: {
    async onSuccess() {
      try {
        const form = this.$refs.form as VueForm
        if (!form.validate()) return
        this.loading = true
        const provider = this.providers.find(
          item => item.uuid === this.crud.parent_provider,
        )
        if (provider && provider.configured === undefined) {
          this.crud.parent_shared = this.crud.parent_provider
          this.crud.parent_provider = null
        }
        const response = await createOrUpdateSharedProvider(this.crud)
        this.$emit('new-item', response.data)
        this.$emit('input', false)
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    try {
      this.loadingProviders = true
      const response = await getAgencyProviders()
      this.providers = response.data.results
    } finally {
      this.loadingProviders = false
    }
  },
})
